import { MutableRefObject, useEffect, useRef } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { NetworkingFormData } from '../../NetworkingForm';

type UseStashTrunkedNetworksParams = {
  isTrunked: boolean;
  watch: UseFormMethods<NetworkingFormData>['watch'];
  initialTrunkedNetworks: string[];
};

export const useStashTrunkedNetworks = ({
  isTrunked,
  watch,
  initialTrunkedNetworks,
}: UseStashTrunkedNetworksParams): MutableRefObject<string[]> => {
  const watchTrunkedNetworks = watch('trunkedNetworks');
  const stashedTrunkedNetworksRef = useRef<string[]>(initialTrunkedNetworks);

  useEffect(() => {
    if (isTrunked && (watchTrunkedNetworks?.length ?? 0) > 0) {
      stashedTrunkedNetworksRef.current = watchTrunkedNetworks ?? [];
    }
  }, [isTrunked, watchTrunkedNetworks]);

  return stashedTrunkedNetworksRef;
};
